import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingOrderDetail } from 'cloud-shared-lib';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable()
export class OrderListService {
  orders: CuttingOrderDetail[];
  onOrdersChanged: BehaviorSubject<CuttingOrderDetail[]> = new BehaviorSubject([]);
  totalCount = 0;

  constructor(private http: HttpClient) {}

  getOrders(
    pageIndex: number,
    pageSize: number,
    filter: string,
    archived: boolean,
    sort: string,
    sortDirection: string
  ): Promise<any> {
    let searchParams = new HttpParams();

    searchParams = searchParams
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('filter', filter)
      .set('archive', archived)
      .set('sort', sort)
      .set('sortDirection', sortDirection);

    return new Promise((resolve, reject) => {
      this.http.get(ApiLinks.order, { params: searchParams }).subscribe((response: any) => {
        this.orders = response.orders;
        this.totalCount = response.totalCount;
        this.onOrdersChanged.next(this.orders);
        resolve(response);
      }, reject);
    });
  }

  hasMatBase(): Observable<boolean> {
    return this.http.get<boolean>(ApiLinks.hasMatBase);
  }

  toggleArchived(orderIds: number[], value: boolean): Observable<void> {
    let searchParams = new HttpParams().set('value', value ? 'true' : 'false');
    orderIds.forEach(id => {
      searchParams = searchParams.append('orderIds', id.toString());
    });
    return this.http
      .post<void>(ApiLinks.orderToggleArchived(), undefined, {
        params: searchParams,
      })
      .pipe(
        tap(() => {
          this.onOrdersChanged.next(this.orders);
        })
      );
  }

  createOrderCopy(orderId: number): Observable<{ orderId: number }> {
    return this.http.post<{ orderId: number }>(ApiLinks.createOrderCopy(orderId), undefined);
  }

  checkAgreemenrAccept(): Observable<{ actual: boolean; news: string; url: string }> {
    return this.http.get<{ actual: boolean; news: string; url: string }>(ApiLinks.client + '/clients-agreement');
  }

  acceptAgreement(): Observable<void> {
    return this.http.post<void>(ApiLinks.client + '/clients-agreement', undefined);
  }

  uniteOrders(ids: number[]): Observable<void> {
    return this.http.post<void>(ApiLinks.order + '/unite', ids);
  }
}
